export default "__VITE_ASSET__af3ab8cc__"